import { NgModule } from '@angular/core';
import { ProjectsModule } from "./projects/projects.module";
import { CoreRoutingModule } from "./core-routing.module";
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SenLoaderInterceptorService } from "../core/common/loader/sen-loader-interceptor.service";
import { SenLoaderService } from "../core/common/loader/sen-loader.service";
import { SenLoaderComponent } from './common/loader/sen-loader.component';
import { materialModule } from '../material.module';

import { StoreModule } from "@ngrx/store";
import { EffectsModule } from '@ngrx/effects';
import { ProjectReducer } from './store/senAppProjects.reducer';
import { projectsEffects } from "./store/senAppProjects.effects";
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

@NgModule({
  declarations: [SenLoaderComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreRoutingModule,
    ProjectsModule,
    materialModule,
    HttpClientModule,
    StoreModule.forRoot({ appData: ProjectReducer }),
    StoreDevtoolsModule.instrument(),
    EffectsModule.forRoot([projectsEffects])
  ],
  providers: [
    SenLoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: SenLoaderInterceptorService, multi: true }
  ],
  exports: [
    SenLoaderComponent
  ]
})
export class CoreModule { }
